import { ChipCarousel } from "components/Environment/shared/Carousel/ChipCarousel";
import React from "react";

interface ComputeLoaderProps {
  animateCarouselLayout?: boolean;
}

const ComputeLoader: React.FC<ComputeLoaderProps> = ({
  animateCarouselLayout,
}) => {
  return (
    <div className="flex flex-col w-full items-center ">
      <div>
        <ChipCarousel animateLayout={animateCarouselLayout} />
      </div>
      <p className="text-white font-mono">Loading Instances...</p>
    </div>
  );
};

export default ComputeLoader;
